<template>
        <p>{{ getWishlistItemsCount }}</p>
</template>

<script>
export default {
    name: "MiniWishlist",

    props: [
        'count',
    ],

    created() {

        // Set initial value of wishlist items in shopping-cart in vuex store...
        this.$store.dispatch('Cart/changeWishlistItemCount', this.count);
    },

    computed: {

        /**
         * Retrieve cart items count from vuex store
         */
        getWishlistItemsCount() {
            return this.$store.getters['Cart/getWishlistItemCount'];
        },
    },

}
</script>
